<template>
  <div class="flex w-full mt-2 mb-3">
    <nav class="flex p-3 w-full bg-blue-50 rounded-lg" aria-label="Search Results">
      <ol role="list" class="flex items-center space-x-1">
        <li>
          <div>
            <a @click.prevent="handleBack" href="#" class="text-blue-400 hover:text-blue-300">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-5 w-5 flex-shrink-0">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75" />
              </svg>
              <span class="sr-only">Back</span>
            </a>
          </div>
        </li>
        <li>
          <div class="flex items-center">
            <span class="ml-4 text-sm font-medium text-blue-400">Upload Files...</span>
          </div>
        </li>
      </ol>
    </nav>
  </div>
</template>

<script>
export default {
  props: {
    breadcrumbs: Array,
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  methods: {
    handleBack(){
      this.$emit('back');
    }
  },
  mounted() {

  }
}
</script>
